export default function fitBounds(cb) {
  // this == React Map component
  const { google, map } = this;

  const bounds = new google.maps.LatLngBounds();
  map.data.forEach(feature => {
    processPoints(google, feature.getGeometry(), bounds.extend, bounds);
  });
  map.fitBounds(bounds);

  if (typeof cb === 'function') cb();
}

function processPoints(google, geometry, callback, thisArg) {
  if (geometry instanceof google.maps.LatLng) {
    callback.call(thisArg, geometry);
  } else if (geometry instanceof google.maps.Data.Point) {
    callback.call(thisArg, geometry.get());
  } else {
    geometry.getArray().forEach(g => processPoints(google, g, callback, thisArg));
  }
}



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/Map/methods/fitBounds.js